import { ReactNode } from 'react'
import { Dialog, DialogProps } from 'primereact/dialog'
import { Button } from 'primereact/button'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface FormModalProps extends DialogProps {
  children: ReactNode
  disabled?: boolean
  onSave?: () => void
  onCancel?: () => void
}

interface IModalFooterProps {
  disabled?: boolean
  onCancel?: () => void
  onSave?: () => void
}

function FooterComponent({ onSave, onCancel, disabled }: IModalFooterProps) {
  const { t } = useTranslation()
  return (
    <ActionArea>
      <CancelButton id="cancelBtn" className="p-button-outlined" label={t('buttons.cancel')} onClick={onCancel} />
      <ConfirmButton id="confirmBtn" disabled={disabled} label={t('buttons.continue')} onClick={onSave} />
    </ActionArea>
  )
}

export default function FormModal({
  children,
  visible,
  onHide,
  onSave,
  onCancel,
  disabled,
  ...dialogProps
}: FormModalProps) {
  return (
    <CustomDialog
      {...dialogProps}
      visible={visible}
      onHide={onHide}
      blockScroll
      keepInViewport
      closeOnEscape={false}
      draggable={false}
      resizable={false}
      focusOnShow={false}
      closable={dialogProps.closable || false}
      position="center"
      style={{ width: '580px', height: '630px' }}
      footer={<FooterComponent onSave={onSave} disabled={disabled} onCancel={onCancel} />}>
      {children}
    </CustomDialog>
  )
}

const CustomDialog = styled<React.ElementType | keyof JSX.IntrinsicElements>(Dialog)`
  .p-dialog-header {
    padding: 1rem 1rem 0.5rem 1.5rem !important;

    .p-dialog-title {
      font-weight: 600;
      font-size: 1rem;
    }
  }
`

const ActionArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -4px;
  margin-top: 20px;
  border-bottom-right-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
`

const CancelButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;

  :disabled {
    opacity: 0.4;
  }
`
const ConfirmButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
